import { useNavigate, useParams } from "react-router-dom";
import { SaveButton, type SaveContentType } from "@/components/ui/SaveButton";
import { useAuth } from "../auth";
import { useFavorites } from "../favorites";
import { useI18n } from "../i18n";

const ENTITY_MAP: Record<
  Exclude<SaveContentType, "itinerary">,
  "destination" | "attraction" | "hotel" | "restaurant" | "experience" | "event"
> = {
  destination: "destination",
  attraction: "attraction",
  hotel: "hotel",
  restaurant: "restaurant",
  experience: "experience",
  event: "event",
};

export function FavoriteSave({
  type,
  id,
  className,
}: {
  type: Exclude<SaveContentType, "itinerary">;
  id: string;
  className?: string;
}) {
  const { t } = useI18n();
  const { user, loading: authLoading } = useAuth();
  const { isSaved, toggle, busyKey } = useFavorites();
  const navigate = useNavigate();
  const { locale } = useParams();
  const entityType = ENTITY_MAP[type];
  const saved = isSaved(entityType, id);
  const busy = busyKey === `${entityType}:${id}`;

  return (
    <SaveButton
      type={type}
      id={id}
      saved={saved}
      className={className}
      label={t("common.save")}
      savedLabel={t("common.saved")}
      onToggle={() => {
        if (authLoading) return;
        if (!user) {
          navigate(`/${locale || "en"}/login?next=saved`);
          return;
        }
        if (busy) return;
        void toggle(entityType, id).catch(() => {
          /* error surfaced via favorites context */
        });
      }}
    />
  );
}
